'use client';

import { NavMain } from '@/components/nav/nav-main';
import { NavUser } from '@/components/nav/nav-user';
import Logo from '@ui/components/ui/logo';
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarMenu, useSidebar } from '@ui/components/ui/sidebar';
import Image from 'next/image';
import NavCredits from './nav-credits';
import NavFeedback from './nav-feedback';
import NavHelp from './nav-help';
import { NavJobSelector } from './nav-job-selector';
import { TeamSwitcher } from './team-switcher';
import Link from 'next/link';
import { useEffect } from 'react';

export function AppSidebar() {
  const { open, isMobile } = useSidebar();

  function isIosSafari26Plus() {
    if (typeof window === 'undefined') return false;

    const ua = navigator.userAgent;

    const isSafari = ua.includes('Safari') && !ua.includes('Chrome') && !ua.includes('Chromium') && !ua.includes('CriOS') && !ua.includes('FxiOS');

    if (!isSafari) return false;

    const isIOS = ua.includes('iPhone') || ua.includes('iPad') || ua.includes('iPod');
    if (!isIOS) return false;

    const versionMatch = ua.match(/Version\/(\d+)/);
    if (!versionMatch) return false;

    const majorVersion = Number(versionMatch[1]);
    return majorVersion >= 26;
  }

  useEffect(() => {
    if (isIosSafari26Plus()) {
      document.documentElement.classList.add('ios-safari-26-plus');
    }
  }, []);

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader className="flex items-center justify-between">
        <Link href="/products">
          {open || isMobile ? <Logo /> : <Image src="/logo-icon.svg" alt="Logo" width={32} height={32} className="min-w-6" />}
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <NavMain />
        <NavJobSelector />
      </SidebarContent>
      <SidebarFooter className="gap-5">
        <SidebarMenu>
          <NavCredits />
        </SidebarMenu>
        <SidebarMenu>
          <NavFeedback />
          <NavHelp />
        </SidebarMenu>
        <SidebarMenu>
          <TeamSwitcher />
          <NavUser />
        </SidebarMenu>
      </SidebarFooter>
    </Sidebar>
  );
}
